import { Alert, Box, Button, FormControl, InputLabel, OutlinedInput, Typography } from "@mui/material";
import { DaymapIcon, DaymapIconType } from "daymap-react";
import { useMemo, useState } from "react";

export function PasswordResetRequest() {
    const [email, setEmail] = useState("");
	const [submitted, setSubmitted] = useState(false);
    const [submitting, setSubmitting] = useState(false);

	const isValidEmail = useMemo(() => {
		if (email.trim() === "") return false;
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
	}, [email]);

	const onSubmit = async () => {
		if (!isValidEmail) return;
        setSubmitting(true);

        const url = new URL(window.location.href);
        const requestUrl = url.searchParams.get("requestUrl") || `${window.location.origin}/portal/auth`;
        const clientId = url.searchParams.get("clientId") || "Connect.API"; 

        const body = {
            Email: email.trim(),
            StudentCode: null,
            RequestUrl: requestUrl,
            ClientId: clientId,
        };

        try 
        {

            const response = await fetch(
                `https://${url.host}/lms/api/password/requestReset`, 
                {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                  },
                body: body ? JSON.stringify(body) : undefined
            });

            const data = await response.json();
            if(!response.ok){
                throw Error((data.message != undefined ? data.message : data.title) ?? "")
            }
        }
        catch(ex:any){
        }

        setSubmitted(true);
        setSubmitting(false);
	};

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				height: "100vh",
				width: "100%",
				px: 2
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					gap: 2,
					width: "100%",
					maxWidth: 420,
					textAlign: "left"
				}}
			>
				<Typography fontSize="2rem" sx={{ textAlign: "center" }}>
					Request a password reset
				</Typography>
				<Typography variant="body2" color="text.secondary">
					Enter the email address registered with the school. A link to reset your password will be emailed to you.
				</Typography>
				<FormControl fullWidth>
					<InputLabel htmlFor="reset-email">Email</InputLabel>
					<OutlinedInput
						id="reset-email"
						label="Email"
						type="email"
						value={email}
						onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
							setEmail(event.target.value);
							if (submitted) setSubmitted(false);
						}}
					/>
				</FormControl>
				<Button 
                    variant="contained" 
                    disabled={!isValidEmail} 
                    loading={submitting}
                    onClick={onSubmit}
                    startIcon={<DaymapIcon iconType={DaymapIconType.Send} />}
                >
					{submitting ? "Sending..." : "Send Reset Email"}
				</Button>
				{submitted && (
					<Alert severity="success">
						If an account exists for this email address, a password reset email has been sent.
					</Alert>
				)}
			</Box>
		</Box>
	);
}
